import { render, staticRenderFns } from "./AcademicProgressLevelPicker.vue?vue&type=template&id=b54a741c&scoped=true"
import script from "./AcademicProgressLevelPicker.vue?vue&type=script&lang=js"
export * from "./AcademicProgressLevelPicker.vue?vue&type=script&lang=js"
import style0 from "./AcademicProgressLevelPicker.vue?vue&type=style&index=0&id=b54a741c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54a741c",
  null
  
)

export default component.exports